import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import frTranslations from './locales/fr.json'
import enTranslations from './locales/en.json'
import arTranslations from './locales/ar.json'

import { LANG_KEY, LANGUAGES } from '@/utils/constants'

const resources = {
  fr: { translation: frTranslations },
  en: { translation: enTranslations },
  ar: { translation: arTranslations },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    lng: localStorage.getItem(LANG_KEY) || 'fr',
    debug: import.meta.env.DEV,
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: LANG_KEY,
    },
    react: {
      useSuspense: false, // Disable suspense to avoid issues with lazy loading
    },
  })

// Set document direction based on language
i18n.on('languageChanged', lng => {
  const language = LANGUAGES.find(l => l.code === lng)
  if (language) {
    document.documentElement.setAttribute('lang', lng)
    document.documentElement.setAttribute('dir', language.dir)
  }
})

export default i18n


